import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import SearchHotelPrefsModal from './SearchHotelPrefsModal';

const searchDelay = 1000;

class SearchHotelForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleEnterKey = this.handleEnterKey.bind(this);
    this.handleShowSearchPrefs = this.handleShowSearchPrefs.bind(this);
    this.onClose = this.onClose.bind(this);
    this.state = {
      search: props.search,
      save: false,
      showSearchPrefs: false
    };
  }
  componentWillMount() {
    this.timer = null;
  }
  handleChange(e) {
    e.preventDefault();
    // clearTimeout(this.timer);
    this.setState({
      search: e.target.value,
      save: true,
    });
    // this.timer = setTimeout(this.triggerSearch, searchDelay);
  }
  handleEnterKey(e) {
    if (e.keyCode === 13) this.handleSearch();
  }
  handleSearch() {
    let savedSearchPrefs = JSON.parse(sessionStorage.getItem('prefs'));
    if(savedSearchPrefs == undefined) {
      savedSearchPrefs = {'brands': [], 'stars': { lower: 0, upper: 0 }}
     }
    if (this.state.search) {
      const payload = {
        searchText: this.state.search,
        stars: savedSearchPrefs.stars,
        brands: savedSearchPrefs.brands
      };
      console.log('Go search: ', this.state.search);
      let hasSearchPrefs = true;
      if(this.props.isAddHotelSearch) {
        hasSearchPrefs = false;
        this.props.requestHotelSearch(this.state.search, hasSearchPrefs, (response)=>{
        //Do Nothing.
       });
      }else{
        this.props.requestHotelSearch(payload, hasSearchPrefs, (response)=>{
          //Do Nothing.
      });
    }
    }
  }
  handleShowSearchPrefs() {
    this.setState({
      showSearchPrefs: true
    })
  }
  onClose(){
    this.setState({
      showSearchPrefs: false
    })
  }

  render() {
    return (
      <div>
        <FormGroup controlId="hotel-search">
          <FormControl
            type="text"
            value={this.state.search}
            placeholder="Search Hotel Name and/or City"
            onChange={this.handleChange}
            onKeyDown={this.handleEnterKey}
          />
          <Button onClick={this.handleSearch}>Search</Button>
          {!this.props.isFetching && !this.props.isAddHotelSearch && (<Button className="search-hotel-preferences-btn" onClick={this.handleShowSearchPrefs}>Search Preferences</Button>)}
        </FormGroup>
        {this.state.showSearchPrefs && (
          <SearchHotelPrefsModal
            show={this.state.showSearchPrefs}
            brandList={this.props.brands}
            brandGroups={this.props.brandGroups}
            onClose={this.onClose}
            handleSearch={this.handleSearch}
          />
        )}
      </div>
    );
  }
}

SearchHotelForm.propTypes = {
  search: PropTypes.string,
  requestHotelSearch: PropTypes.func.isRequired,
};
SearchHotelForm.defaultProps = {
  search: null,
};

export default SearchHotelForm;



// WEBPACK FOOTER //
// src/routes/hotels/components/SearchHotelForm.js